<template>
  <div class="rounded-xl bg-white/80 p-4 shadow-sm dark:border-slate-700/70 dark:bg-slate-900/40">
    <div class="mb-2 flex items-center justify-between">
      <h3 class="text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-500 dark:text-slate-400">
        {{ title }}
      </h3>
      <slot name="icon" />
    </div>
    <p
      class="text-xl font-semibold text-slate-800 transition-all duration-300 dark:text-slate-100 sm:text-2xl"
      :class="isRefreshing ? 'scale-[0.98]' : 'scale-100'"
    >
      {{ value }}
    </p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  value: string | number;
  isRefreshing?: boolean;
}>();
</script>
